<template>
  <figure class="identity__logo ba-text-center ba-mb-8 md:ba-mb-36 md:ba-w-76 lg:ba-w-140">
    <img src="/img/brand/white/gray-logo.svg" class="ba-mb-4 ba-w-48 md:ba-w-76 ba-inline" />
    <h1
      class="ba-mt-8 ba-text-xl md:ba-text-3xl ba-text-center"
    >Информационно-образовательная цифровая платформа ВДЦ «Смена»</h1>
    <p
      v-if="false"
      class="ba-hidden lg:ba-block ba-text-center ba-max-w-sm ba-mt-5"
    >Описание</p>
  </figure>
</template>

<script>
export default {
  name: "vis-login-header"
};
</script>
